import { useRef, useState } from 'react'
import { Tag } from 'antd'
import Tooltip from '$components/Tooltip'
import PropTypes from 'prop-types'

const TruncateTag = ({
  icon,
  iconWidth = 0,
  text,
  addedTooltip = '',
  maxWidth = '120px',
  fontSize = '12px',
  variant,
  color,
}) => {
  const textRef = useRef(null)
  const [showTooltip, setShowTooltip] = useState(false)

  const handleOverflow = () => {
    if (textRef.current) {
      setShowTooltip(textRef.current.scrollWidth > textRef.current.offsetWidth)
    }
  }

  return (
    <Tooltip title={showTooltip ? text + ' ' + addedTooltip : addedTooltip}>
      <Tag
        icon={icon}
        style={{ maxWidth, fontSize }}
        variant={variant}
        color={color}
        onMouseEnter={handleOverflow}
        onMouseLeave={() => setShowTooltip(false)}
      >
        <span
          ref={textRef}
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'inline-block',
            verticalAlign: 'middle',
            maxWidth: `calc(100% - ${iconWidth}px)`,
          }}
        >
          {text}
        </span>
      </Tag>
    </Tooltip>
  )
}

TruncateTag.propTypes = {
  icon: PropTypes.node,
  text: PropTypes.string.isRequired,
  addedTooltip: PropTypes.string,
  maxWidth: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
  iconWidth: PropTypes.number,
  fontSize: PropTypes.string,
}

export default TruncateTag
